import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

import { SharedModule } from 'app/shared/shared.module';
import { BufferGraphComponent } from 'app/buffer-graph/components/buffer-graph.component/buffer-graph.component';
import { BufferGraphChartComponent } from 'app/buffer-graph/components/buffer-graph-chart.component/buffer-graph-chart.component';
import { BufferGraphService } from 'app/buffer-graph/services/buffer-graph.service';
import { ResizeGlyphModule } from 'app/resize-glyph/resize-glyph.module';
import { BufferGraphModalComponent } from 'app/buffer-graph/components/buffer-graph-modal.component/buffer-graph-modal.component';
import { SlickGridModule } from 'app/slick-grid/slick-grid.module';
import { ItemOrderHistoryComponent } from 'app/buffer-graph/components/item-order-history.component/item-order-history.component';
import { BufferChangeHistoryComponent } from 'app/buffer-graph/components/buffer-change-history.component/buffer-change-history.component'
import { ItemActionsComponent } from 'app/buffer-graph/components/item-actions.component/item-actions.component';
import { BufferChangeReasonsComponent } from 'app/buffer-graph/components/buffer-change-reasons.component/buffer-change-reasons.component';
import { SuppliersSchedulesComponent } from 'app/buffer-graph/components/suppliers-schedules.component/suppliers-schedules.component';
import { AssortmentStructureComponent } from 'app/buffer-graph/components/assortment-structure.component/assortment-structure.component';
import { ChangeBufferComponent } from './components/change-buffer.component/change-buffer.component';

@NgModule({
    imports: [CommonModule, SharedModule, TranslateModule.forChild(), ResizeGlyphModule, SlickGridModule, FormsModule],
    declarations: [
        BufferGraphComponent,
        BufferGraphChartComponent,
        BufferGraphModalComponent,
        ItemOrderHistoryComponent,
        BufferChangeHistoryComponent,
        ItemActionsComponent,
        BufferChangeReasonsComponent,
        SuppliersSchedulesComponent,
        AssortmentStructureComponent,
        ChangeBufferComponent
    ],
    exports: [
        BufferGraphComponent,
        BufferGraphModalComponent,
        ItemOrderHistoryComponent,
        BufferChangeHistoryComponent,
        ItemActionsComponent,
        BufferChangeReasonsComponent,
        SuppliersSchedulesComponent,
        AssortmentStructureComponent
    ]
})
export class BufferGraphModule {
    static forRoot(): ModuleWithProviders {
        return { ngModule: BufferGraphModule, providers: [BufferGraphService] };
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/buffer-graph.module.ts